import type { LegendAnalyzerError } from './legend-engine'

/**
 * Thrown when the engine can't compute a legend version, because the
 * analyzer found errors in it.
 */
export class LegendComputeError extends Error {
  constructor(
    message: string,
    readonly errors: LegendAnalyzerError[],
    cause: unknown,
  ) {
    super(message, { cause })
    this.name = 'LegendComputeError'
  }
}
